export const getLocationName = city => city.name || '';
